import { useNavigate, useParams } from "react-router-dom";
import InfoChip from "../components/common/InfoChip";
import { ModifierGroup, Severity } from "../types";
import {
  useFetchModifierGroupDetailsQuery,
  useUpdateModifierGroupMutation,
} from "../store";
import ModifierGroupForm from "../forms/ModifierGroup.form";
import { modifierGroupSchema } from "../configs";
import { showToast, ToastType } from "../utils/toast.utils";

const EditModifierGroupWrapper = () => {
  const { modifierGroupId } = useParams();

  if (!modifierGroupId)
    return (
      <InfoChip severity={Severity.DANGER} content="Restaurant Introuvable" />
    );

  return <EditModifierGroup modifierGroupId={modifierGroupId} />;
};

interface EditModifierGroupProps {
  modifierGroupId: string;
}

const EditModifierGroup: React.FC<EditModifierGroupProps> = ({
  modifierGroupId,
}) => {
  const [updateModifierGroup, { isLoading }] = useUpdateModifierGroupMutation();
  const { data: modifierGroupDetails, isFetching } =
    useFetchModifierGroupDetailsQuery(modifierGroupId);
  const navigate = useNavigate();

  if (isLoading || isFetching) return <div> loading... </div>;

  if (!modifierGroupDetails)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Groupe de suppléments Introuvable"
      />
    );

  return (
    <div className="w-full flex flex-col items-center p-4">
      <ModifierGroupForm
        initialValues={modifierGroupDetails}
        validationSchema={modifierGroupSchema}
        restaurantId={modifierGroupDetails.restaurant}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          values.modifierOptions = values.modifierOptions.map(
            (group: ModifierGroup) => group._id
          );
          const result = await updateModifierGroup({
            modifierGroupId,
            body: values,
          });
          if (!result.error) {
            showToast("Groupe de supplément mis à jour", ToastType.SUCCESS);
            resetForm();
            navigate("/modifier-groups");
          }
        }}
      />
    </div>
  );
};

export default EditModifierGroupWrapper;
